import { useContext, useEffect, useState } from "react";
import UserContext from "context/UserContext";
import { useGestionCustomer } from "hooks/useGestionCustomer";
import performRequest from "network/perform-request";
import { leagueCustomerFeaturesRoute } from "network/api-routes";

export function useGestionShellCompetition() {
  const { customerId } = useGestionCustomer();
  const { user } = useContext(UserContext);
  const [shell, setShell] = useState(null);
  // X-03: { allowed, code, message }; null while unknown (the create endpoint still enforces it).
  const [tournamentCreation, setTournamentCreation] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!customerId) {
      setShell(null);
      setTournamentCreation(null);
      setReady(true);
      return;
    }
    setReady(false);
    performRequest("GET", leagueCustomerFeaturesRoute(customerId), {}, true, user)
      .then((response) => {
        setShell(response.data?.gestion_competition || null);
        setTournamentCreation(response.data?.tournament_creation || null);
      })
      .catch(() => {
        setShell(null);
        setTournamentCreation(null);
      })
      .finally(() => setReady(true));
  }, [customerId, user]);

  return { shell, ready, customerId, tournamentCreation };
}
